import { UploadFilesRepository } from "@common/domain/repositories/UploadFilesRepository";
import {
  call,
  ForkEffect,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { uploadActions } from "@common/redux/upload/actions";
import {
  IFetchFileAction,
  IUploadFileDataAction,
  IUploadFormFileDataAction,
  IUploadFormFilesDataAction,
  IUploadFormLogoDataAction,
} from "@common/redux/upload/interface";

function* UploadFileSaga(action: IUploadFileDataAction) {
  const { onSuccessFileUpload, onFailureFileUpload } = action.payload;
  try {
    const response = yield call(
      UploadFilesRepository.uploadProfilePic,
      action.payload
    );
    onSuccessFileUpload(response);
  } catch (error) {
    onFailureFileUpload(error);
  }
}

function* UploadFormFileSaga(action: IUploadFormFileDataAction) {
  const { onSuccessFileUpload, onFailureFileUpload } = action.payload;
  try {
    const formFileUploadResponse = yield call(
      UploadFilesRepository.uploadFormFile,
      action.payload
    );
    onSuccessFileUpload(formFileUploadResponse);
  } catch (error) {
    onFailureFileUpload(error);
  }
}


function* UploadFormFilesSaga(action: IUploadFormFilesDataAction) {
  const { onSuccessFilesUpload, onFailureFilesUpload } = action.payload;
  try {
    const formFilesUploadResponse = yield call(
      
      UploadFilesRepository.uploadFormFiles,
      action.payload
    );
       
    onSuccessFilesUpload(formFilesUploadResponse);    
  } 

  
  catch (error) {
    onFailureFilesUpload(error);
  }
}


function* UploadFormLogoSaga(action: IUploadFormLogoDataAction) {
  const { onSuccessFileUpload, onFailureFileUpload } = action.payload;
  try {
    const formFileUploadResponse = yield call(
      UploadFilesRepository.uploadFormLogo,
      action.payload
    );
    if (formFileUploadResponse && formFileUploadResponse.data) {
      onSuccessFileUpload(formFileUploadResponse);
    } else {
      onFailureFileUpload(formFileUploadResponse.message);
    }
  } catch (error) {
    onFailureFileUpload(error.message);
  }
}

function* FetchFileSaga(action: IFetchFileAction) {
  const { onSuccessFileFetch, onFailureFileFetch, fileName,applicationId } = action.payload;
  try {
    const response = yield call(
      UploadFilesRepository.fetchProfilePic,
      fileName,
      applicationId
    );
    const fetchFileSuccessPayload = {
      file: response.data,
      fileName: fileName,
    };
    onSuccessFileFetch(fetchFileSuccessPayload);
  } catch (e) {
    onFailureFileFetch(e.message);
  }
}

export function* watchFiles(): Generator<ForkEffect> {
  yield takeLatest(uploadActions.UPLOAD_FILE, UploadFileSaga);
  yield takeEvery(uploadActions.UPLOAD_FORM_FILE, UploadFormFileSaga);
  yield takeEvery(uploadActions.FETCH_FILE, FetchFileSaga);
  yield takeEvery(uploadActions.UPLOAD_FORM_LOGO, UploadFormLogoSaga);
  yield takeLatest(uploadActions.UPLOAD_FORM_FILES, UploadFormFilesSaga);
}
